(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.overlayEnabled = this.dataset.overlayHeader === 'true';
      this.headerSection = document.getElementById(this.dataset.headerSectionId);

      this.setHeaderHeight();
      this.updateOverlayPosition();

      this.onResizeHandler = () => {
        this.setHeaderHeight();
        this.updateOverlayPosition();
      };

      window.addEventListener('resize', this.onResizeHandler);
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    updateOverlayPosition() {
      if (!this.overlayEnabled || !this.headerSection) return;

      /*
        Anchor the overlay header directly below the Brand Switch.
        The previous version summed every previous sibling in the DOM,
        which can include PageFly/template content in the Theme Editor
        and create a very large false top offset.
      */
      const brandSwitch =
        document.querySelector('.brand-switch')?.closest('.shopify-section') ||
        document.querySelector('[class*="brand-switch"]')?.closest('.shopify-section');

      const announcementBar =
        document.querySelector('.announcement-bar')?.closest('.shopify-section') ||
        document.querySelector('[class*="announcement"]')?.closest('.shopify-section');

      const anchor = brandSwitch || announcementBar;

      if (!anchor) {
        this.headerSection.style.setProperty('--dynamic-overlay-top', '0px');
        return;
      }

      const anchorRect = anchor.getBoundingClientRect();
      const offsetParent = this.headerSection.offsetParent || document.documentElement;
      const parentRect = offsetParent.getBoundingClientRect();

      const overlayTop = anchorRect.bottom - parentRect.top + offsetParent.scrollTop;
      this.headerSection.style.setProperty('--dynamic-overlay-top', `${Math.max(0, overlayTop)}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.matchMedia('(max-width: 990px)').removeEventListener('change', this.onResizeHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.overlayEnabled && this.headerSection) {
        this.headerSection.classList.toggle('dynamic-header-is-scrolled', scrollTop > 20);
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
